import { call, put, takeEvery } from 'redux-saga/effects';
import { changePriceOMConfig } from '../../requests/change_priceom_config_request';
import { changePriceOMConfigRequestSuccess, changePriceOMConfigRequestFailure } from '../actions/change_priceom_config.actions';
import { CHANGE_PRICEOM_CONFIG_REQUEST } from '../constants/priceom_config.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* changePriceOMRequest({ _id, config }) {
    const changed_config = yield call(changePriceOMConfig, _id, config); const
        { result, options } = changed_config;
    if (result) {
        yield put(changePriceOMConfigRequestSuccess(options));
        message_success('Priceomatic Configuration changed successfully!');
    } else {
        yield put(changePriceOMConfigRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changePriceOMSaga() {
    yield takeEvery(CHANGE_PRICEOM_CONFIG_REQUEST, changePriceOMRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/redux/sagas/change_priceom_config.saga.js